import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl, NgModel } from '@angular/forms';

@Component({
  selector: 'app-form-error-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './form-error-message.component.html',
  styleUrl: './form-error-message.component.scss'
})
export class FormErrorMessageComponent {

  @Input() control!: NgModel | AbstractControl;
  @Input() errorMessage: string | null = '';
  @Input() formSubmitted: boolean = false;
  @Input() isEnabled: boolean = false;

}
